import config from '../config';
import { isDev, isElectron } from 'services/env-service';

export const getDomainName = hostName => {
    if (isElectron() || isDev()) {
        return hostName;
    }

    return hostName.substring(hostName.lastIndexOf('.', hostName.lastIndexOf('.') - 1) + 1);
};

export const getTeamUrlFromUrl = () => {
    const particles = window.location.hostname.split('.');

    if (isDev() || particles.length !== 3) {
        return null;
    }

    return particles[0];
};

export const buildAppUrl = (path = '') => {
    const protocol = config.APP_DOMAIN === 'localhost' ? 'http://' : 'https://';
    const port = config.APP_DOMAIN === 'localhost' ? ':3001' : '';

    return protocol + config.APP_DOMAIN + port + path;
}

export const corsFree = url => `${config.HOST}/cors?cd=${url}`;
